import { Text } from '@ltvco/refresh-lib/theme';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import {
  CardContainer,
  CardHeaderRow,
  ReportTitle,
  SeeFullReportCTA,
  ViewReportButton,
} from '../../components';

import { UsernamePlatformSection, UsernameOwnersSection } from './sections';

import type { UsernameReportData } from 'components/DeepSearch/types';

interface UsernameReportPreviewCardProps {
  data: UsernameReportData;
  onViewReport?: () => void;
  onViewReportForOwner?: (ownerName: string, bvId?: string) => void;
}

export const UsernameReportPreviewCard = ({
  data,
  onViewReport,
  onViewReportForOwner,
}: UsernameReportPreviewCardProps) => (
  <CardContainer>
    <CardHeaderRow sx={{ alignItems: 'flex-start', mb: 1 }}>
      <AlternateEmailIcon sx={{ fontSize: 24, mt: '4px', flexShrink: 0 }} />
      <div>
        <ReportTitle m={0}>{data.username || 'Username Report'}</ReportTitle>
        <Text sx={{ fontSize: 14, color: 'text.secondary' }}>
          Username search
        </Text>
      </div>
      {onViewReport && <ViewReportButton onClick={onViewReport} />}
    </CardHeaderRow>

    {data.platforms.length > 0 && (
      <UsernamePlatformSection platforms={data.platforms} />
    )}

    {(data.potentialOwner ||
      Boolean(data.ownerName) ||
      data.otherPotentialOwners.length > 0) && (
      <UsernameOwnersSection
        data={data}
        onViewReportForOwner={onViewReportForOwner}
      />
    )}
    {onViewReport && <SeeFullReportCTA onClick={onViewReport} />}
  </CardContainer>
);
